import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";
const STATUS = {
  active: "Active",
  inactive: "Inactive",
  blocked: "Blocked",
  deleted: "Deleted",
  pending: "Pending",
};
const Columns = ({ handleViewMail, currentPage, pageSize }) => {
  return [
    {
      dataField: "",
      text: "SrNo",
      formatter: (cell, row, rowIndex) => (
        <span className="text-capitalize cursor-pointer">
          {(currentPage - 1) * pageSize + (rowIndex + 1)}
        </span>
      ),
    },

    {
      dataField: "Genrated By User",
      text: "Genrated By User",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">{row.genratedBy}</span>
      ),
    },
    {
      dataField: "Genrated By Email",
      text: "Genrated By Email",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row.genratedByEmail}
        </span>
      ),
    },
    {
      dataField: "email1_count",
      text: "Email Count",
      formatter: (_, row) => (
        <span className="text-capitalize cursor-pointer">
          {row?.emails.length || "--"}
        </span>
      ),
    },
    {
      text: "Created At",
      dataField: "createdAt",
      formatter: (_, row) => DATE_FORMAT(row.createdAt),
    },
    {
      text: "Action",
      dataField: "",
      formatter: (_, row) => (
        <>
          <span className="d-flex gap-1">
            <button
              className="fa fa-eye"
              style={{
                fontSize: "20px",
                color: "green",
                backgroundColor: "#fff",
                border: "none",
              }}
              title="View"
              onClick={() => handleViewMail(row)}
            ></button>
          </span>
        </>
      ),
    },
  ];
};

export default Columns;
